import React, { useEffect } from "react";

const COLORS = ["#ff4081", "#ffeb3b", "#4caf50", "#29b6f6", "#ab47bc", "#ff9800"];

function randomBetween(min, max) {
  return Math.random() * (max - min) + min;
}

export default function CelebrationOverlay({ message, subtext, onClose, duration = 3500 }) {
  useEffect(() => {
    if (!onClose) return undefined;
    const id = setTimeout(() => onClose(), duration);
    return () => clearTimeout(id);
  }, [onClose, duration]);

  const pieces = Array.from({ length: 24 }).map((_, idx) => {
    const left = randomBetween(0, 100);
    const delay = randomBetween(0, 0.6);
    const fall = randomBetween(40, 60);
    const rotate = randomBetween(-45, 45);
    return (
      <span
        key={idx}
        style={{
          position: "absolute",
          top: "-10px",
          left: `${left}%`,
          width: 8,
          height: 14,
          background: COLORS[idx % COLORS.length],
          borderRadius: 2,
          opacity: 0.9,
          animation: `confettiFall ${fall / 10}s ease-in ${delay}s forwards`,
          transform: `rotate(${rotate}deg)`
        }}
      />
    );
  });

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    }}>
      <style>
        {`@keyframes confettiFall {
            0% { transform: translateY(0) rotate(0deg); opacity: 1; }
            100% { transform: translateY(120vh) rotate(360deg); opacity: 0; }
        }`}
      </style>
      <div style={{ position: "absolute", inset: 0 }}>
        {pieces}
      </div>
      <div style={{
        background: "rgba(0,0,0,0.75)",
        color: "#fff",
        padding: "24px 32px",
        borderRadius: 16,
        textAlign: "center",
        boxShadow: "0 12px 30px rgba(0,0,0,0.3)",
        maxWidth: 360,
        pointerEvents: "auto"
      }}>
        <div style={{ fontSize: 24, fontWeight: 700 }}>{message}</div>
        {subtext && <div style={{ marginTop: 8, fontSize: 16 }}>{subtext}</div>}
      </div>
    </div>
  );
}
